import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IKBCatalog, IKBCatalogCategory, IKBCatalogCategoryLearned, KBLearnedStatus } from '../interfaces/IBase-knowledge-catalog';
@Component({
  selector: 'biz-base-knowledge-catalog-learned',
  templateUrl: './base-knowledge-catalog-learned.component.html',
  styleUrls: ['./base-knowledge-catalog-learned.component.scss']
})
export class BaseKnowledgeCatalogLearnedComponent {
  public InProgress = KBLearnedStatus.InProgress;
  public Completed = KBLearnedStatus.Completed;
  public Failed = KBLearnedStatus.Failed;
  public Delivered = KBLearnedStatus.Delivered;
  public NotExecuted = KBLearnedStatus.NotExecuted;
  public Awaiting = KBLearnedStatus.Awaiting;
  public NotFound = KBLearnedStatus.NotFound;
  public ErrorSearching = KBLearnedStatus.ErrorSearching;

  @Input() filteredCategoryListLearned: IKBCatalogCategoryLearned[] = [];
  @Output() refreshKBLearnedOutput = new EventEmitter<Guid>();

  constructor() { }

  toggleCategory(category: IKBCatalogCategory): void {
    category.Expanded = !category.Expanded;
  }

  toggleCatalog(catalog: IKBCatalog): void {
    catalog.Expanded = !catalog.Expanded;
  }

  onToggleSelectAll(status: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
  }

  refreshKBLearned(kbLearned: any) {
    this.refreshKBLearnedOutput.emit(kbLearned.Id);
  }

  getSortedKBLearned(category: any): any[] {
    return category.KBLearned ? [...category.KBLearned].sort((a: any, b: any) => 
      a.DisplayName.localeCompare(b.DisplayName)
    ) : [];
  }
}
